
import { post } from "../../services/http-services";

export function testNotification(notifyModel) {
    return post(`/notification/testnotification`, notifyModel);
}